import type { RouteLocationRaw, RouteRecordRaw } from 'vue-router';

import { locationSessionStorageKey } from './keycloak';

export const createOAuthCbRoutes = (path: string, defaultRouteName: string): RouteRecordRaw[] => [{
  path,
  redirect: (): RouteLocationRaw => {
    const defaultRoute = { hash: '', name: defaultRouteName, replace: true };
    const lastLocation = sessionStorage.getItem(locationSessionStorageKey);

    if (!lastLocation) {
      return defaultRoute;
    }

    const parsedLocation = JSON.parse(lastLocation) as Location;

    // prevent endless redirect
    if (parsedLocation.pathname.includes(path)) {
      return defaultRoute;
    }

    // redirect to requested location
    return {
      hash: parsedLocation.hash,
      path: parsedLocation.pathname.replace('/v3', '').replace('/admin', ''), // v3 & admin fix
      query: Object.fromEntries(new URLSearchParams(parsedLocation.search).entries()),
      replace: true,
    };
  },
  meta: {
    dontSaveRedirect: true,
  },
}];
